module.exports = __webpack_public_path__ + "img/icon-notes-2.47fa58f0.svg";